import axios from 'axios';

export const netlifyHook = () => axios({
	method: 'post',
	url:'https://api.netlify.com/build_hooks/6904ac9bf45e8d745f217c8a'
});

export default netlifyHook;